import { useEffect, useRef } from "react";
import { onlineManager, useQueryClient } from "@tanstack/react-query";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";

export function useNetworkQuerySync() {
  const isOnline = useNetworkStatus();
  const queryClient = useQueryClient();
  const prev = useRef(isOnline);
  useEffect(() => {
    try { onlineManager.setOnline(isOnline); } catch { /* noop */ }
    if (!prev.current && isOnline) {
      // Reconnected — pull fresh live data.
      try { queryClient.invalidateQueries(); } catch { /* noop */ }
    }
    prev.current = isOnline;
  }, [isOnline, queryClient]);
}
